// import { refreshContent } from "./refreshContent";
import { updateURL } from "./updateURL";
/* This is what we use to control whether the passages show up on the days of the month calendar that extend beyond the given month to allow for a lookahead and perfect grid. */
let outsideCalendar;
export function getOutsideCalendar() {
    return outsideCalendar;
}
export function setOutsideCalendar(newOutsideCalendar, options) {
    newOutsideCalendar =
        newOutsideCalendar === "true" || newOutsideCalendar === true
            ? true
            : false;
    if (newOutsideCalendar === outsideCalendar) {
        return outsideCalendar;
    }
    const ignoreRefresh = options === null || options === void 0 ? void 0 : options.ignoreRefresh;
    // outsideCalendar = newOutsideCalendar && newOutsideCalendar !== false;
    outsideCalendar = newOutsideCalendar;
    window.localStorage.setItem("outsideCalendar", String(outsideCalendar));
    if (!ignoreRefresh) {
        const notMonths = [...document.querySelectorAll(".not-month")];
        for (let i = 0, l = notMonths.length; i < l; i++) {
            const notMonth = notMonths[i];
            const icon = notMonth.querySelector("i.fa-solid");
            const button = notMonth.querySelector("button");
            notMonth.classList.toggle("showDate");
            icon.classList.toggle("fa-eye");
            icon.classList.toggle("fa-eye-slash");
            button.setAttribute("value", String(!outsideCalendar));
        }
        // refreshContent();
        updateURL();
    }
    return outsideCalendar;
}
